import * as React from 'react';


type ScrollOptimizerProps = {
	enabled?: boolean;
	isScrolling: boolean;
	style?: React.CSSProperties;
}

class ScrollOptimizer extends React.Component<ScrollOptimizerProps> {
	static displayName = 'ScrollOptimizer';

	shouldComponentUpdate(nextProps: ScrollOptimizerProps) {
		if (nextProps.enabled) {
			return !nextProps.isScrolling;
		}

		return true;
	}

	render() {
		return (
			<div style={this.props.style}>
				{this.props.children}
			</div>
		);
	}
}

export default ScrollOptimizer;
